var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotaljsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    strokeMiterlimit: 1.41400003,
    width: 64,
    height: 64,
    fillRule: "evenodd",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.325245 0 0 1.325245 -72.811733 -14.97665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.09 11.3L100 23.374V47.52L79.09 59.594 58.177 47.52V23.374zm.023 14.003l8.364 4.83v9.66l-8.364 4.83-8.365-4.83v-9.66z",
    fill: "#66b639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.624 35.112l-3.097 6.876-6.943.106 3.176-6.933-3.26-7.06 6.84-.02 3.284 6.816.07.063-.035.077.036.076zm-3.464 7.46l-5.064 11.272L58.192 47.5V23.283l11.1-6.33 4.804 10.65-7.528-.043 3.562 7.528-3.458 7.586z",
    fill: "#9ad959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.12 53.8l4.787-10.608.252-.612-1.04.017 1.393-.605 4.61 2.753-4.95 11.894z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3 16.96l4.5-2.606 4.46 11.496-3.984 2.24-1.34-.462 1.164-.015z",
    fill: "url(#B)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x2: 77.474,
    gradientUnits: "userSpaceOnUse",
    x1: 71.447,
    y1: 45.733,
    y2: 49.149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67b13d",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#1a2d10",
    stopOpacity: 0.153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67b13d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x2: 74.831,
    gradientUnits: "userSpaceOnUse",
    x1: 70.119,
    y1: 23.211,
    y2: 19.868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67b13d",
    stopOpacity: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0e2600",
    stopOpacity: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67b13d",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotaljsIcon);
export default __webpack_public_path__ + "static/media/totaljs-icon.74b010c5cd69221c220b5a22eda63c29.svg";
export { ForwardRef as ReactComponent };